import sliceCreator from '../../index.jsx';
import {GET_DAILY_TASK_BY_ID} from '../../../constants/index.jsx';
const _getDailyTaskByIdAction = sliceCreator('GET_DAILY_TASK_BY_ID', GET_DAILY_TASK_BY_ID, 'get');

const { asyncAction: getDailyTaskByIdAction, reducer, clearData: clearGetDailyTaskByIdAction } = _getDailyTaskByIdAction;

export default reducer;

export {
    getDailyTaskByIdAction,
    clearGetDailyTaskByIdAction
}